import classNames from 'classnames'
import styles from './index.module.scss'
import AddressHash from '@/components/AddressHash'
import { useTranslation } from 'react-i18next'
import { ugagToGag } from '@/utils/number'
import { useGlobalStore } from '@/hoxStore/globalStore'
import MeEmpty from '@/components/MeEmpty'
import Loading from '@/components/LoadingCom'
import { navigateQueryExistsFn } from '@/utils'
import useMeNavigate from '@/hooks/useMeNavigate'

const CommitteeElectionVoteInfo = ({
  loading,
  type,
  data = {},
}: {
  loading: boolean
  type: string
  data: any
}) => {
  const { t } = useTranslation()
  const { curReponsive } = useGlobalStore()
  const { committee_candidate_infos } = data || {}
  const navigate = useMeNavigate()
  return type === 'gea.committee.MsgEndElectoral' ? (
    <div className={styles.committeeElectionVoteInfoContainer}>
      <div className={classNames('font_14', styles.committeeElectionVoteInfoTitle)}>
        {t('explorer_309')}:
      </div>
      <div className={styles.committeeElectionVoteInfoContentWrapper}>
        <div className={styles.committeeElectionVoteInfoHeader}>
          <div className={styles.committeeElectionVoteInfoHeaderItem}>{t('explorer_307')}</div>
          <div className={styles.committeeElectionVoteInfoHeaderItem}>{t('explorer_114')}</div>
          <div className={styles.committeeElectionVoteInfoHeaderItem}>{t('explorer_308')}</div>
        </div>
        <div
          className={classNames({
            [styles.committeeElectionVoteInfoContentList]: true,
            [styles.committeeElectionVoteInfoContentListEmpty]: !committee_candidate_infos?.length,
            [styles.committeeElectionVoteInfoContentListLoading]: loading,
          })}
        >
          {loading && <Loading></Loading>}
          {committee_candidate_infos?.length > 0 ? (
            <>
              {committee_candidate_infos?.map((item: any, index: number) => (
                <div className={styles.committeeElectionVoteInfoContent} key={index}>
                  <div className={styles.committeeElectionVoteInfoContentItem}>
                    {/* {item.candidate_id} */}
                    {index + 1}
                  </div>
                  <div className={styles.committeeElectionVoteInfoContentItem}>
                    <AddressHash
                      data={item.candidate_address}
                      handleJump={() => {
                        navigateQueryExistsFn(item.candidate_address, navigate)
                      }}
                      cutOption={curReponsive?.size === 'mobile'}
                    ></AddressHash>
                  </div>
                  <div className={styles.committeeElectionVoteInfoContentItem}>
                    {ugagToGag(item.vote_amount_ugag).value}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <MeEmpty></MeEmpty>
          )}
        </div>
      </div>
    </div>
  ) : null
}

export default CommitteeElectionVoteInfo
